import { render, staticRenderFns } from "./org_target_list.vue?vue&type=template&id=014d10d8&scoped=true"
import script from "./org_target_list.vue?vue&type=script&lang=js"
export * from "./org_target_list.vue?vue&type=script&lang=js"
import style0 from "./org_target_list.vue?vue&type=style&index=0&id=014d10d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d10d8",
  null
  
)

export default component.exports